document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".mobile-toggle").forEach((button) => {
      button.addEventListener("click", function () {
        const nextPanel = button.nextElementSibling;
        if (nextPanel && nextPanel.classList.contains("mobile-submenu-wrapper")) {
            nextPanel.toggleAttribute("hidden");
            const svg = button.querySelector("svg");
            if (svg) {
                svg.classList.toggle("reversed-icon");
            }
        }
      });
    });
}); 